import { BodyText } from '@/utils/global-fonts';
import { MdArrowRight } from 'react-icons/md';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 150px;
  overflow: auto;
`;

const CategoriesContainer = styled.div`
  min-height: 150px;
  overflow: auto;
`;

const ListWrapper = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  font-size: 14px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  padding-inline-start: ${({ $hasParent }) => ($hasParent ? '15px' : '0')};
`;

const CloseOpenButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: ${({ $hasChildren }) => ($hasChildren ? 'pointer' : 'normal')};
  opacity: ${({ $hasChildren }) => ($hasChildren ? 1 : 0)};
  font-size: 16px;
  margin-right: 12px;
  padding: 0;
  width: 16px;
  height: 16px;
  border-radius: 5%;
`;

const ItemLabel = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const ActionArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  height: 56px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 0px 0px 4px 4px;
`;

const OpenGroupIcon = styled(MdArrowRight)`
  rotate: 90deg;
  font-size: 24px;
  cursor: pointer;
`;

const ClosedGroupIcon = styled(MdArrowRight)`
  cursor: pointer;
  font-size: 24px;
`;

const ActionText = styled(BodyText)`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
  text-align: left;
`;

const CategoryUploadAction = styled.div`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  gap: 8px;
  width: auto;
  cursor: pointer;
  margin-top: auto;
`;

const styledCategory = {
  ListWrapper,
  ListItem,
  ItemLabel,
  CloseOpenButton,
  ActionArea,
  Container,
  OpenGroupIcon,
  ClosedGroupIcon,
  ActionText,
  CategoryUploadAction,
  CategoriesContainer,
};

export default styledCategory;
